import React from 'react';
import style from '../../../PaperworkList/PaperworkList.module.css';
import s from '../../FinancialReport.module.css';
import {FinReportType} from '../../../../types/StoreReportTypes';

type Props = {
	row: FinReportType;
	fields: (keyof FinReportType)[];
	gridClass: string;
};

const SimpleReportTableRowEl: React.FC<Props> = ({row, fields, gridClass}) => {
	// Відображаємо тільки ті поля, які вказані в fields
	const rowValues = fields.map(field => row[field]);

	return (
		<div className={`${style.tableRow} ${s.tableRow} ${s[gridClass]}`}>
			{rowValues.map((val, i) => (
				<div key={i} className={`${style.tableColumn} ${s.tableColumn}`}>
					{val}
				</div>
			))}
		</div>
	);
};

export default SimpleReportTableRowEl;

